import React from 'react';
import './Equipo.css';
import brushStroke from '../assets/images/brush-stroke.webp';

import equipo1 from '../assets/images/equipo1.webp';
import equipo2 from '../assets/images/equipo2.webp';
import equipo3 from '../assets/images/equipo3.webp';

const miembros = [
  { nombre: 'Asier Leoz',    imagen: equipo1 },
  { nombre: 'Ángel García',  imagen: equipo2 },
  { nombre: 'Daniel Lanz',   imagen: equipo3 },
];

export default function Equipo() {
  return (
    <section className="equipo-container">
      {/* Título unificado con pincelada */}
      <h1 className="equipo-titulo">
        <div className="title-container">
          <img src={brushStroke} alt="" className="brush-behind-title" />
          <span className="title-text">Nuestro Equipo</span>
        </div>
      </h1>

      {/* Tarjetas del equipo */}
      <div className="equipo-grid">
        {miembros.map((miembro, idx) => (
          <div className="equipo-card" key={idx}>
            <div className="equipo-img-wrapper">
              <img src={miembro.imagen} alt={miembro.nombre} />
            </div>
            <h2 className="equipo-nombre">{miembro.nombre}</h2>
          </div>
        ))}
      </div>
    </section>
  );
}
